// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3RfMr","footer":"ChangeClinic_footer__1ztMH"};